module.exports = __webpack_public_path__ + "static/media/howitworks-4.ce0181de.png";